// Iter 108v — KanbanBoard extracted from Helpdesk.jsx.
//
// Presentation-only board of ticket columns. All state (tickets,
// agents, drag ref, permissions) lives on the parent Helpdesk page
// and is passed down as props so this component stays reusable and
// hooks-free.

import { Circle, Clock, PauseCircle, CheckCircle2 } from "lucide-react";
import { TicketCard } from "./TicketCard";
import { COLUMNS } from "./helpdeskUtils";

const COL_ICON = {
  new:         Circle,
  in_progress: Clock,
  on_hold:     PauseCircle,
  solved:      CheckCircle2,
};

export function KanbanBoard({
  columns, agents, canAgent, canManage,
  onOpenTicket, onDeleteTicket, onDragStart, onColumnDrop,
}) {
  const allowDrop = (e) => { e.preventDefault(); };
  return (
    <div className="flex h-full gap-3 overflow-x-auto p-3" data-testid="helpdesk-kanban">
      {COLUMNS.map((col) => {
        const Icon = COL_ICON[col.key] || Circle;
        const bucket = columns[col.key] || [];
        return (
          <div key={col.key}
               onDragOver={allowDrop} onDrop={(e) => onColumnDrop(e, col.key)}
               className="flex min-w-[16rem] flex-1 basis-0 flex-col rounded-lg border border-slate-200 bg-white"
               data-testid={`helpdesk-col-${col.key}`}>
            <div className={`flex items-center justify-between rounded-t-lg border-b ${col.tint} px-3 py-2`}>
              <div className="flex items-center gap-2 text-sm font-semibold">
                <Icon className="h-3.5 w-3.5" /> {col.label}
              </div>
              <span className="text-xs opacity-80">{bucket.length}</span>
            </div>
            <div className="flex-1 space-y-2 overflow-y-auto p-2">
              {bucket.map((t) => (
                <TicketCard key={t.ticket_id} t={t} agents={agents}
                            onOpen={() => onOpenTicket(t)}
                            draggable={canAgent}
                            canManage={canManage}
                            onDelete={() => onDeleteTicket(t)}
                            onDragStart={(e) => onDragStart(e, t)} />
              ))}
              {bucket.length === 0 && (
                <div className="rounded border border-dashed border-slate-200 py-6 text-center text-xs text-slate-400">
                  No tickets
                </div>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}
